module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-Honey.db57a1e8.jpg";